import styled from 'styled-components';
import { theme } from '../../../../../global';

export const HeaderContainer = styled.div`
  background-color: ${theme.colors.header};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 72px;
  border-bottom: 1px solid #b0b0ed;
  z-index: 1000;
  position: fixed;
  left: 0px;
  top: 0px;

  @media (min-width: 1100px) {
    width: 0px;
    height: 0px;
    position: absolute;
    right: -100px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const Pseudo = styled.div`
  width: 32px;
`;
